import { Controller } from "@hotwired/stimulus"

// Toggles the free-text "qual cargo?" field on the "Adicionar membro" form —
// it only makes sense when the manager picks "Outro" in the cargo select;
// for the fixed options (Presidente, Técnico, etc.) it stays hidden so
// nobody has to type a role that's already covered by the dropdown.
export default class extends Controller {
  static targets = ["select", "customRole", "customRoleInput"]

  toggle() {
    const isOther = this.selectTarget.value === "outro"
    this.customRoleTarget.classList.toggle("hidden", !isOther)
    this.customRoleInputTarget.toggleAttribute("required", isOther)
    if (!isOther) this.customRoleInputTarget.value = ""
  }
}
